import { FailedIcon, SuccessIcon } from '@assets/icons';
import { CalendarBlueIcon, InformationIcon } from '@assets/icons/index';
import { Box, Flex, SimpleGrid, Text } from '@chakra-ui/react';
import { ConditionalComponent } from '@components/functionComponent';
import SkeletonComponent from '@components/skeleton';
import useGetAuditTrailSummary from '@domain/auditTrail/useGetAuditTrailSummary';
import SummaryCard from '@pages/AuditTrailSellOut/components/SummaryCard';
import periodeConverter from '@pages/AuditTrailSellOut/helpers/periodeConverter';
import { useFilter } from '@pages/AuditTrailSellOut/state/filters';

const Summary = () => {
    const { status, setFilter } = useFilter();

    const { data, isLoading } = useGetAuditTrailSummary();
    const periode = periodeConverter(data?.start_date, data?.end_date);

    const syncDate = data?.sync_date;
    const successSellOut = data?.success_api;
    const failedSellOut = data?.failed_api;
    const totalError = data?.total_error;
    const period = periode;

    const summaryData = [
        { Icon: CalendarBlueIcon, title: 'Periode', value: period, isFilter: false, isFiltered: false },
        {
            Icon: SuccessIcon,
            title: 'Sellout Berhasil',
            value: `${successSellOut} Sellout`,
            isFilter: true,
            filterKey: { id: 'success', name: 'success' },
            isFiltered: status?.some((item) => item.id === 'success'),
        },
        {
            Icon: FailedIcon,
            title: 'Sellout Gagal',
            value: `${failedSellOut} Sellout`,
            isFilter: true,
            filterKey: { id: 'failed', name: 'failed' },
            isFiltered: status?.some((item) => item.id === 'failed'),
        },
        { Icon: FailedIcon, title: 'Jumlah Error', value: `${totalError} Error`, isFilter: false, isFiltered: false },
    ];

    const handleFilterClick = (key) => {
        setFilter({
            status: status.some((item) => item.id === key.id)
                ? status.filter((item) => item.id !== key.id)
                : [...status, key],
        });
    };

    return (
        <Box
            bg={'white'}
            p={'24px'}
            border={'1px solid'}
            borderColor={'neutral.100'}
            borderRadius={'8px'}
            boxShadow={'sm'}
            mb={'6'}
        >
            <Flex justifyContent="space-between" mb="16px" flexWrap={'wrap'} gap={'8px'}>
                <Text fontSize={'xl'} fontWeight={'bold'}>
                    Audit Trail Summary
                </Text>

                <Flex gap="8px" alignItems="center">
                    <Box>
                        <InformationIcon />
                    </Box>
                    <ConditionalComponent
                        statement={!isLoading}
                        fallback={<SkeletonComponent height={'24px'} width={'250px'} />}
                    >
                        <Text>
                            Terakhir diperbarui pada{' '}
                            <Box display={'inline'} fontWeight={'bold'}>
                                {syncDate}
                            </Box>
                        </Text>
                    </ConditionalComponent>
                </Flex>
            </Flex>

            <SimpleGrid columns={{ base: 2, lg: 3, xl: 4 }} gap="24px">
                {summaryData.map((item, index) => (
                    <SummaryCard
                        key={index}
                        {...item}
                        isLoading={isLoading}
                        onClick={item.isFilter ? () => handleFilterClick(item.filterKey) : undefined}
                    />
                ))}
            </SimpleGrid>
        </Box>
    );
};

export default Summary;
